import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDuplicate = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_6339_32029)",
			children: /* @__PURE__ */ _jsx("path", { d: "M9.31152 1.23145H13.9756C14.3384 1.23145 14.6868 1.37626 14.9434 1.63281C15.1996 1.88927 15.3437 2.23704 15.3438 2.59961V13.7998C15.3438 14.1626 15.1999 14.511 14.9434 14.7676C14.6868 15.0241 14.3384 15.168 13.9756 15.168H12.6025C12.5302 15.3001 12.4395 15.4228 12.3311 15.5312C12.031 15.8312 11.6244 16 11.2002 16H2.40039C1.97605 16 1.56861 15.8313 1.26855 15.5312C0.968683 15.2313 0.799908 14.8245 0.799805 14.4004V0H7.97656L9.31152 1.23145ZM2.40039 14.4004H11.2002V5.59961H6.82422V1.59961H2.40039V14.4004ZM12.7998 4.44922V13.5684H13.7432V2.83203H11.0469L12.7998 4.44922ZM8.42383 4H9.95312L8.42383 2.58887V4Z" })
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6339_32029",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgDuplicate);
export default ForwardRef;
